module.exports = __webpack_public_path__ + "static/img/10.dfc69e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/10.png
// module id = DBBz
// module chunks = 0